import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/common";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inbox from "@/pages/Inbox";
import Clienti from "@/pages/Clienti";
import ClienteDetail from "@/pages/ClienteDetail";
import Pratiche from "@/pages/Pratiche";
import PraticaDetail from "@/pages/PraticaDetail";
import Preventivi from "@/pages/Preventivi";
import PreventivoEditor from "@/pages/PreventivoEditor";
import Sopralluoghi from "@/pages/Sopralluoghi";
import Promemoria from "@/pages/Promemoria";
import Impostazioni from "@/pages/Impostazioni";
import Simulatore from "@/pages/Simulatore";
import Assistenza from "@/pages/Assistenza";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import VerifyEmail from "@/pages/VerifyEmail";
import Billing from "@/pages/Billing";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import ForcePasswordChange from "@/pages/ForcePasswordChange";
import PlatformDashboard from "@/pages/PlatformDashboard";
import Landing from "@/pages/Landing";
import Register from "@/pages/Register";
import { Privacy, Terms, Cookies, Contact, DataDeletion } from "@/pages/LegalPages";
import TrialGate from "@/components/TrialGate";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center"><Loading /></div>;
  if (user === false) return <Navigate to="/welcome" replace />;
  if (user.must_change_password) return <ForcePasswordChange />;
  if (user.role === "PLATFORM_OWNER") return <PlatformDashboard />;
  return <TrialGate><Layout>{children}</Layout></TrialGate>;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/welcome" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/cookies" element={<Cookies />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/data-deletion" element={<DataDeletion />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/" element={<Protected><Dashboard /></Protected>} />
        <Route path="/inbox" element={<Protected><Inbox /></Protected>} />
        <Route path="/inbox/:convId" element={<Protected><Inbox /></Protected>} />
        <Route path="/clienti" element={<Protected><Clienti /></Protected>} />
        <Route path="/clienti/:id" element={<Protected><ClienteDetail /></Protected>} />
        <Route path="/pratiche" element={<Protected><Pratiche /></Protected>} />
        <Route path="/pratiche/:id" element={<Protected><PraticaDetail /></Protected>} />
        <Route path="/preventivi" element={<Protected><Preventivi /></Protected>} />
        <Route path="/preventivi/:id" element={<Protected><PreventivoEditor /></Protected>} />
        <Route path="/sopralluoghi" element={<Protected><Sopralluoghi /></Protected>} />
        <Route path="/promemoria" element={<Protected><Promemoria /></Protected>} />
        <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
        <Route path="/simulatore" element={<Protected><Simulatore /></Protected>} />
        <Route path="/assistenza" element={<Protected><Assistenza /></Protected>} />
        <Route path="/abbonamento" element={<Protected><div className="max-w-4xl mx-auto p-4 sm:p-6"><Billing /></div></Protected>} />
        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/cancel" element={<BillingCancel />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
